import React from "react";

import "./step-description.scss";

interface StepDescriptionInterface {
  number: number;
  title: string;
  description: any;
}

const StepDescription = (props: StepDescriptionInterface) => {
  const { number, title, description } = props;

  return (
    <div className="m-stepDescription__details-info">
      <div className="m-stepDescription__details-numbercontainer">
        <p className="m-stepDescription__details-number">{number}</p>
      </div>

      <p className="m-stepDescription__details-title">{title}</p>
      {description && (
        <div className="m-stepDescription__details-desc">{description}</div>
      )}
    </div>
  );
};

export default StepDescription;
